// extracted by mini-css-extract-plugin
module.exports = {"empty":"index-module_empty_Bo9Hn","empty__img":"index-module_empty__img_1w7I1","empty__text":"index-module_empty__text_3s3E9","empty__buy":"index-module_empty__buy_1cYmJ"};